module.exports = "images/location_grocery.d89130482e1604d1fc29b4fb5869c9b3.png";